import { Form, Grid, Select, TextField } from '@approvalmax/ui/src/components';
import { memo } from 'react';
import { useCompanyCountries } from 'shared/hooks/(wallets)/kyc/useCompanyCountries';

import { messages } from './AddressFormPart.messages';
import type { AddressFormPartProps } from './AddressFormPart.types';

export const AddressFormPart = memo<AddressFormPartProps>((props) => {
    const { prefix } = props;

    const { countries, isCountriesLoading } = useCompanyCountries();

    const getInputName = (name: string) => `businessInformation.${prefix}.${name}`;
    const getQaName = (name: string) => `${prefix}.${name}`;

    return (
        <Form.Part>
            <Grid gap={16}>
                <Grid gap={16} gridTemplateColumns='1fr 1fr'>
                    <TextField
                        required
                        name={getInputName('street')}
                        qa={getQaName('street')}
                        label={messages.street}
                        placeholder={messages.streetPlaceholder}
                    />

                    <TextField
                        required
                        name={getInputName('buildingNumber')}
                        qa={getQaName('buildingNumber')}
                        label={messages.buildingNumber}
                        placeholder={messages.buildingNumberPlaceholder}
                    />
                </Grid>

                <TextField
                    name={getInputName('apartmentNumber')}
                    qa={getQaName('apartmentNumber')}
                    label={messages.apNumber}
                    placeholder={messages.apNumberPlaceholder}
                />

                <TextField
                    required
                    name={getInputName('buildingName')}
                    qa={getQaName('buildingName')}
                    label={messages.buildingName}
                    placeholder={messages.buildingNamePlaceholder}
                />

                <TextField
                    name={getInputName('state')}
                    qa={getQaName('state')}
                    label={messages.stateOrProvince}
                    placeholder={messages.stateOrProvincePlaceholder}
                />

                <Grid gap={16} gridTemplateColumns='1fr 1fr'>
                    <TextField
                        required
                        name={getInputName('city')}
                        qa={getQaName('city')}
                        label={messages.city}
                        placeholder={messages.cityPlaceholder}
                    />

                    <TextField
                        required
                        name={getInputName('postalCode')}
                        qa={getQaName('postalCode')}
                        label={messages.postalCode}
                        placeholder={messages.postalCodePlaceholder}
                    />
                </Grid>

                <Select
                    disabled
                    name={getInputName('country')}
                    qa={getQaName('country')}
                    items={countries}
                    progress={isCountriesLoading}
                />
            </Grid>
        </Form.Part>
    );
});

AddressFormPart.displayName = 'AddressFormPart';
